import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/build/repo/iznik-nuxt3/modtools/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/opt/build/repo/iznik-nuxt3/modtools/layouts/empty.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/opt/build/repo/iznik-nuxt3/layouts/login.vue").then(m => m.default || m)),
  "no-navbar": defineAsyncComponent(() => import("/opt/build/repo/iznik-nuxt3/layouts/no-navbar.vue").then(m => m.default || m))
}